/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { WorkspaceTrainingJobFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TrainingJobsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TrainingJobsQuery = { __typename?: 'QueryPrediction', trainingJobs: Array<{ __typename?: 'TrainingJob', id: string, name: string, created: any, modified: any, elapsedTimeSeconds: number, instanceType: { __typename?: 'InstanceType', name: string, gpuCount: number, gpuType: Types.GpuType | null | undefined }, status: { __typename?: 'TrainingJobStatusType', value: Types.TrainingJobStatus, created: any }, project: { __typename?: 'TrainingProject', name: string } } | null | undefined> | null | undefined };


export const TrainingJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainingJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingJobs"},"name":{"kind":"Name","value":"training_jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkspaceTrainingJobFragment"}}]}}]}},...WorkspaceTrainingJobFragmentDoc.definitions]} as unknown as DocumentNode<TrainingJobsQuery, TrainingJobsQueryVariables>;
export const namedOperations = {
  Query: {
    TrainingJobs: 'TrainingJobs'
  }
}

/**
 * __useTrainingJobsQuery__
 *
 * To run a query within a React component, call `useTrainingJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrainingJobsQuery(baseOptions?: Apollo.QueryHookOptions<TrainingJobsQuery, TrainingJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingJobsQuery, TrainingJobsQueryVariables>(TrainingJobsDocument, options);
      }
export function useTrainingJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingJobsQuery, TrainingJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingJobsQuery, TrainingJobsQueryVariables>(TrainingJobsDocument, options);
        }
export type TrainingJobsQueryHookResult = ReturnType<typeof useTrainingJobsQuery>;
export type TrainingJobsLazyQueryHookResult = ReturnType<typeof useTrainingJobsLazyQuery>;
export type TrainingJobsQueryResult = Apollo.QueryResult<TrainingJobsQuery, TrainingJobsQueryVariables>;
export function refetchTrainingJobsQuery(variables?: TrainingJobsQueryVariables) {
      return { query: TrainingJobsDocument, variables: variables }
    }